export default {
  // 郵件
  email: {
    email: '郵件',
    refresh: '刷新',
    theme: '主題',
    sender: '發件人',
    time: '時間',
    addressee: '收件人',
    inbox: '收件箱',
    hasBeenSent: '已發送',
    drafts: '草稿箱',
    csPersonnel: '抄送人',
    emailContent: '郵件內容',
    themeIsMustfill: '主題是必填項',
    senderIsMustfill: '發件人是必填項',
    addresseeIsMustfill: '收件人是必填項',
    emailContentIsMustfill: '郵件內容是必填項',
    inputEmailAddress: '輸入郵箱地址',
    rightEmailAddress: '請輸入正確的郵箱地址',
    copyTo: '取消抄送',
    blindCarbonCopy: '密送',
    massTexting: '群發單顯',
    write: '寫信',
    enclosure: '附件',
    individual: '個',
    sendMail: '發郵件',
    recordContacts: '往來記錄',
    mailList: '通訊錄',
    deleted: '已刪除',
    dustbin: '垃圾箱',
    label: '標簽',
    mailSet: '郵件設置',
    bindTip: '請先將您的郵箱進行綁定，綁定後才可進行使用。',
    bindMyEmail: '綁定我的郵箱',
    messageSynchronizationSucceeded: '同步第三方郵件成功',
    classify: '分類',
    formName: '表單名稱',
    permission: '訪問權限',
    linkAddress: '鏈接地址',
    QRcodeSharing: '掃二維碼，分享給好友',
    sigeCode: '簽到二維碼',
    downloadCode: '下載二維碼',
    extendedLink: '擴展鏈接',
    formLinkTip: '對同壹個表單賦予多個鏈接地址，用於標識不同數據提交來源。',
    personalTemplate: '個人模板',
    companyTemplate: '機構模板',
    allCustomerCategories: '所有客戶分類',
    notFollowedUpInSevenDay: '七天未跟進',
    productionManage: '生產管理',
    mailTemplate: '郵件模板',
    dataTemplate: '數據模板',
    webLinkTemplate: 'WEB鏈接模版',
    copied: '已復制至剪切板',
    sign: '簽到',
    pwdVisit: '密碼訪問',
    publicVisit: '公開訪問',
    background: '背景',
    backgroundTip: '請選擇設置背景',
    backgroundColor: '背景顏色',
    customColor: '自定義顏色',
    backgroundImage: '背景圖片',
    clickUpdate: '點擊上傳',
    updateFileTip: '只能上傳 jpg/png 文件,且不超過 500kb',
    pictureTile: '圖片平鋪',
    name: '姓名',
    mailAddress: '郵箱地址',
    addTime: '添加時間',
    selectOneData: '請選擇壹條數據',
    name_empty: '姓名不能為空',
    mailAddress_empty: '郵箱地址不能為空',
    mailAddress_error: '郵箱地址格式不正確',
    markedRead: '標記已讀',
    unreadMark: '標記未讀',
    urgentMail: '緊急郵件',
    regularMail: '定時郵件',
    draft: '草稿',
    partialSuccess: '部分成功',
    failInSend: '發送失敗',
    approvalAdopt: '審批通過',
    approvalReject: '審批駁回',
    sendReadIsSend: '要求發送 "已讀回執"，是否發送',
    send: '發送',
    noSend: '不發送',
    selectReminderTime: '選擇提醒時間',
    remindYourselfOnly: '僅提醒自己',
    timingTransmission: '定時發送',
    preview: '預覽',
    roughDraft: '存草稿',
    deleteThoroughly: '徹底刪除',
    secretAgent: '密送人',
    addAttachments: '添加附件',
    addAttachmentFromFileLibrary: '從文件庫中添加附件',
    insertMailTemplate: '插入郵件模版',
    insertModuleData: '插入模塊數據',
    insertWebForm: '插入WEB表單',
    urgent: '緊急',
    receiptRequired: '需要回執',
    pureText: '純文本',
    encryptMessage: '對郵件加密',
    useSignature: '使用簽名',
    recentContacts: '最近聯系人',
    selectContacts: '選擇聯系人',
    selectFromModules: '從模塊中選擇',
    selectFromAddressBook: '從通訊錄中選擇',
    modular: '模塊',
    regularMailTip: '此郵件是定時郵件，將在',
    issue: '發出',
    yymmddhhmm: 'yyyy年 MM月 dd日 HH時 mm分',
    sendTime: '發送時間',
    editTime: '修改時間',
    EmailWillBeSentTo: '本郵件將在',
    sendToOppositeEmail: '發送到對方郵箱',
    selectAttachmentFromFileLibrary: '從文件庫中選擇附件',
    areYouSure: '你確定要',
    selectedMail: '選中的郵件嗎？',
    mayPass: '可通過',
    backgroundCustomLayout: '後臺-自定義模塊-頁面布局',
    add: '進行添加。',
    gotIt: '知道了',
    copySuccess: '復制成功',
    selectApprover: '選擇審批人',
    nextStep: '下壹環節',
    approver: '審批人',
    adopt: '通過',
    specifyNextApprover: '指定下壹審批人',
    selectMembers: '選擇成員',
    CC: '抄送',
    cancelSecretDelivery: '取消密送',
    cancelGroupReleaseSingleDisplay: '取消群發單顯',
    mailboxFormatOutOfLimit: '郵箱格式超出限制',
    reply: '回復',
    wrote: '寫道',
    forward: '轉發',
    technologicalProcess: '流程',
    notSelectExpirationTime: '請不要選擇已過期的時間',
    pleaseSelectContact: '請選擇聯系人',
    enterApprovalPhase: '您的郵件已進入審批環節，請在審批模塊查看',
    successfulReply: '回復成功',
    forwardingSuccess: '轉發成功',
    mailCont0ent_error: '郵件內容不能為空',
    theme_error: '主題不能為空',
    ddressee_empty: '收件人不能為空',
    sender_empty: '發件人不能為空',
    approver_empty: '審批人不能為空',
    chooseWhereAdd: '請選擇需要添加的位置',
    mailboxDuplicate: '郵箱已重復',
    renturn: '返回',
    replyAll: '回復全部',
    withAccessories: '帶附件',
    rejection: '拒收',
    moveTo: '移動到',
    rditSendAgain: '再次編輯發送',
    markedAs: '標記為',
    alreadRead: '已讀',
    unread: '未讀',
    markAllRead: '全部標記為已讀',
    mailFrom: '發來的郵件',
    myMail: '我發送的郵件',
    seal: '封',
    sentMe: '發給我的',
    iSent: '我發送的',
    deleteTip: '你確定要徹底刪除選中的郵件嗎？',
    selectActionItem: '請選擇需要進行操作的選項',
    noMessagesSelected: '未選中郵件',
    onlyOneDataSelected: '只能選擇壹條數據',
    exportMail: '導出選中郵件',
    altogether: '共',
    notSpam: '這不是垃圾郵件',
    addBusinessCardSignature: '添加名片簽名',
    addTextSignature: '添加文本簽名',
    signatureTitle: '簽名標題',
    applicableAccount: '適用賬號',
    founder: '創建人',
    default: '默認',
    defaultSignature: '默認簽名',
    signatureTitle_empty: '簽名標題不能為空',
    applicableAccount_empty: '適用賬號不能為空',
    businessCardStyle: '名片樣式',
    pleaseSelectAtLeastOneData: '請選擇至少壹條數據',
    dataSource: '數據源',
    templateName: '模版名稱',
    private: '私密',
    public: '公開',
    modified: '修改人',
    template: '模板',
    type: '類型',
    updateTemplate: '上傳模版',
    description: '描述',
    sampleTemplateDownLoad: '示例模版下載',
    templateDeleteTip: '你確定要刪除該模板嗎',
    customTemplateName: '自定義模版名稱',
    salesManage: '銷售管理',
    templateName_empty: '模板名稱不能為空',
    tempCotent_empty: '模板內容不能為空',
    accountManage: '賬號管理',
    disributionRule: '收信規則',
    signatureSet: '簽名設置',
    blackAndWhileList: '黑白名單',
    labelSet: '標簽設置',
    addRule: '添加規則',
    ruleName: '規則名稱',
    ruleName_empty: '規則名稱不能為空',
    enable: '狀態',
    enable_empty: '狀態不能為空',
    triggerEven: '觸發事件',
    triggerCondition: '觸發條件',
    performOperation: '執行操作',
    otherOperations: '其他操作',
    receiving: '接收 (臨時存放在垃圾箱中)',
    reject: '拒絕 (直接刪除)',
    moveTop: '移動至',
    autoReply: '自動回復',
    receivedMail: '收到郵件',
    contains: '包含',
    notIncluded: '不包含',
    EQUALS: '等於',
    NEQUALS: '不等於',
    GREATER: '大於',
    LESS: '小於',
    GREATERE: '大於等於',
    LESSE: '小於等於',
    mailSize: '郵件大小',
    editRule: '編輯規則',
    addLabel: '添加標簽',
    editLabel: '編輯標簽',
    labelName: '標簽名稱',
    labelName_empty: '標簽名稱不能為空',
    selectColor: '選擇顏色',
    myName: '我的名字',
    onlyOneDataCanAdded: '每次只能添加壹條數據',
    black: '黑名單',
    white: '白名單',
    as: '如',
    addWhite: '添加白名單',
    addBlack: '添加黑名單',
    115: '111111',
    inputTip: '請輸入壹個郵箱地址或域名後綴，添加後將拒收該地址來信。',
    inputTip2: '請輸入壹個郵箱地址或域名後綴。',
    editAccount: '編輯賬號',
    toAuthorize: '前往授權',
    authorizeTip: '您當前要綁定的郵箱地址為',
    authorizeTip2: '，根據網易郵箱要求，在驗證通過後請至',
    authorizeTip3: '進行授權，若不授權則可能會無法接收郵件',
    verifySuccess: '驗證成功',
    cannotVerifyMultipleAccount: '不能同時驗證多個賬號',
    addAccount: '添加賬號',
    verify: '驗證',
    automaticCollectionTip: '新賬號綁定後將自動收取最近三個月的郵件',
    OnlyIMAPProtocolSupported: '僅支持IMAP協議。郵局如果已有此功能，請勿勾選',
    authorizeTip4: '將郵局已發箱中的郵件同步到系統已發箱(僅支持IMAP協議)',
    synchronizationSentBoxes: '已發箱是否同步',
    sendSynchronization: '發件是否同步',
    encryptedTransmission: '加密傳輸',
    mustBeEmailAddress: '必須為郵箱地址',
    authorization: '授權碼',
    authorization_empty: '授權碼不能為空',
    setAuthorization: '請在郵箱設置中獲取服務授權碼',
    authorizeTip5: '請在郵箱中開啟POP3/SMTP獲取授權碼，在',
    set: '【設置】',
    account: '【帳戶】',
    servers: '【POP3/SMTP...服務】',
    getAuthorization: '中開啟服務，獲取授權碼',
    nickname: '昵稱',
    receivingServerType: '接收服務器類型',
    receivingServerType_empty: '接收服務器類型不能為空',
    receivingServer: '收件服務器',
    receivingServer_empty: '收件服務器類型不能為空',
    port: '端口',
    port_empty: '端口不能為空',
    outgoingServer: '發件服務器',
    outgoingServer_empty: '發件服務器類型不能為空',
    synchronizationSentboxes: '已發箱是否同步',
    introduction: '打通第三方郵件功能，收發郵件不再來回切換查看',
    mailQuery: '數據查詢',
    mailProcess: '流程管理',
    1111: '保存並使用',
    1112: '重置',
    1113: '撤銷',
    nodeAttribute: '節點屬性',
    nodeAttribute_empty: '請選擇節點',
    nodeName: '節點名稱',
    nodeNameNaxLength15: '只能輸入15個字符',
    branchCondition: '分支條件',
    setBranchCondition: '設置分支條件',
    terminationApprover: '終止審批人',
    approverTip: '只要終止審批人審批過後，審批單就不再繼續往上流轉、終止審批人可以多選。',
    approvalWay: '審批方式',
    approvalTurn: '依次審批',
    onceApproval: '（本環節內審批人壹次審批）',
    jointlySign: '會簽',
    jointlySignTip: '（所有審批人同時收到審批，且所有人需同意方可算審批通過）',
    orSign: '或簽',
    orSignTip: '（所有審批人同時收到審批，只需壹個人審批通過或拒絕即可）',
    originator: '發起人的',
    throughMethod: '通過方式',
    thereIsDraftBox: '存在草稿箱,由發件人手動發送',
    directToCustomer: '直接發送給客戶',
    over: '結束',
    start: '開始',
    dragAddNewNode: '拖拽添加新節點',
    saving: '保存中...',
    mailData: '郵件數據',
    deleteTip2: '此操作將永久刪除郵件, 是否繼續?',
    receipt: '收件',
    hairParts: '發件',
    templatePermission: '模版權限',
    templatePermissionNote: '用於控制郵件設置中機構模版和數據模版的新增、編輯和刪除權限。',
    templateManage: '模板管理員',
    addManage: '添加管理員',
    synchronization: '同步',
    synchronizationtimesetting: '同步時間設置',
    selectfromorganizationalstructure: '從組織架構中選擇',
    synchronizationtimesettingTip: '新郵件信息同步時間設置，每',
    synchronizationtimesettingTip2: '次。系統自動去第三方拉去新郵件信息。',
    synchronousOption1: '實時',
    synchronousOption2: '1個小時',
    synchronousOption3: '無，按系統固定規則拉取',
    newmailshare: '新建郵件共享',
    mailshareTip:
      '通過該功能設定指定的人員可以查看某些成員的郵件往來。比如經理查看下級成員的郵件往來，總監可以查看所有人員的郵件往來。',
    sharesetting: '共享設置',
    closepreview: '關閉該預覽',
    // 20210305
    tentatively: '暫定者',
    scheduleoverdue: '日程已過期',
    bindemailremark:
      '系統公用發件郵箱，用於消息推送、工作流自動化、審批流程和業務流程中發送郵件作為發件人使用，公用郵箱通常有客服郵箱、業務郵箱、人事郵箱等。',
    emailAddress: '郵件地址',
    bindEmail: '綁定郵箱',
    name_empty2: '名稱不能為空',
    port_error: '端口格式不正確',
    delAddressTip: '確定要刪除該郵件地址嗎？'
  }
}
